import Vue from 'vue'
// import App from './App'
// import router from './router/routers'
import store from './store'
//拦截多次触发重新登录变量
window.isShow = true;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router/routers';
Vue.use(ElementUI)
import {pieChart} from '@/assets/shareFuncation/Charts'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/style/index.scss' // global css
import '@/style/my_style.scss'
import './router/index' // permission control
import '@/icons/index' // icon
// // import VueSignaturePad from "vue-signature-pad";
// Vue.use(VueSignaturePad);


import vueEsign from 'vue-esign'
Vue.use(vueEsign)
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import VueAMap from 'vue-amap';
import Attribute from '@/utils/attribute';
Vue.use(Attribute);
// Vue.use(initNIM);
Vue.use(preview);
Vue.use(VueAMap);
function generateUUID() {
    // 创建一个包含字符的模板字符串
    let d = new Date().getTime(); // 使用当前时间
    let d2 = (performance && performance.now && (performance.now()*1000)) || 0; // 使用高精度时间，如果可用

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16; // 生成随机数
        if(d > 0){ 
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r&0x3|0x8)).toString(16);
    });
}
function formatCurrency(amount, decimalPlaces, currencySymbol) {
    // 确保金额是数字
    const number = Number(amount);
    // 格式化金额，设置小数点和千分位分隔符
    const formatted = number.toLocaleString("en-US", {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });
    // 如果提供了货币符号，则添加到格式化结果前面
    return currencySymbol ? `${currencySymbol}${formatted}` : formatted;
  }
Vue.prototype.formatCurrency=formatCurrency;
Vue.prototype.generateUUID=generateUUID;
Vue.prototype.pieChart=pieChart
VueAMap.initAMapApiLoader({
    key: '2d21d8bb186aeda6c3c21f10dd04e732',
    plugin: ['Autocomplete', 'PlaceSearch', 'Geocoder', 'ToolBar', 'Transfer'],
    v: '2.0'
});
Vue.directive('dbClick', {
    inserted(el, binding) {
        console.log(111);
        el.addEventListener('click', e => {
            let time = el.getAttribute('data-dbtime') || 1500;
            if (!el.disabled) {
                el.disabled = true
                el.style.cursor = 'not-allowed'
                setTimeout(() => {
                    el.style.cursor = 'pointer'
                    el.disabled = false
                }, time)
            }
        })
    }
})

Vue.config.productionTip = false;

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js